/* This file was generated automatically. Do not edit manually. */

export enum PaymentRequestReason {
    Other = 'Other',
    PaymentCardMissing = 'PaymentCardMissing',
    PaymentCardDeclined = 'PaymentCardDeclined',
    Deposit = 'Deposit',
    Prepayment = 'Prepayment',
    Fee = 'Fee',
    RecurringPayment = 'RecurringPayment',
}
